import { Tag } from '@ekhodealer/ekho-common/rev';

/**
 * Map payment status to Tag accent color
 */
const getPaymentStatusAccent = (
	status: string | undefined,
): 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
	if (!status) return 'neutral';

	const normalizedStatus = status.toLowerCase();

	switch (normalizedStatus) {
		case 'fully paid':
			return 3; // Teal/Green
		case 'downpayment paid':
		case 'financing guaranteed':
		case 'reservation paid':
			return 5; // Orange
		case 'no payments':
		case 'lost dispute':
		case 'dispute lost':
			return 'neutral'; // Grey
		default:
			return 'neutral';
	}
};

interface PaymentStatusTagProps {
	status?: string;
}

/**
 * Shared component for rendering payment status as a Tag.
 * Can be used in both table cells (with popover) and detail sections (without popover).
 */
export const PaymentStatusTag = ({ status }: PaymentStatusTagProps) => {
	const statusText = status || '—';
	const accent = getPaymentStatusAccent(status);

	return <Tag size='medium' accent={accent} children={statusText} />;
};
